export function isImmutable(obj) {
  // @ts-expect-error intentionally not adding a dep on immutable
  return typeof obj.keySeq === 'function';
}